import { normalizeActivityLabel } from "./streamActivityLabels";
import { upsertRow } from "./timelineRows";

export function reuseByLabel(rows, label, patch) {
  const index = rows.findIndex(
    (item) => item.label === label && item.status !== "failed",
  );
  if (index === -1) return null;
  const next = rows.slice();
  next[index] = { ...next[index], ...patch };
  return next;
}

export function appendToolActivity(rows, event, seq) {
  const label = normalizeActivityLabel(event.label);
  const patch = {
    tool: event.tool ?? null,
    label,
    status: "running",
    taskId: event.task_id ?? null,
    attribution: event.attribution ?? null,
    startedSeq: typeof seq === "number" ? seq : null,
    startedAt: new Date().toISOString(),
  };
  if (event.activity_id)
    return upsertRow(rows, { id: event.activity_id, ...patch });
  return (
    reuseByLabel(rows, label, patch) ?? [
      ...rows,
      { id: `${event.run_id}:${seq ?? rows.length}`, ...patch },
    ]
  );
}
